import { render, staticRenderFns } from "./ProductInventorySection.vue?vue&type=template&id=186ddaeb"
import script from "./ProductInventorySection.vue?vue&type=script&lang=js"
export * from "./ProductInventorySection.vue?vue&type=script&lang=js"
import style0 from "./ProductInventorySection.vue?vue&type=style&index=0&id=186ddaeb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports